import { KgInsightSentiment } from '@api/api/kg-insights';

import styles from './SentimentBreakdownCard.module.scss';

export const SENTIMENT_ORDER: KgInsightSentiment[] = [
  'positive',
  'negative',
  'neutral',
];

export const SENTIMENT_CONFIG: Record<
  KgInsightSentiment,
  { labelKey: string; className: string; chartColor: string }
> = {
  positive: {
    labelKey: 'tailwind',
    className: styles.positive,
    chartColor: '--viz-bullish',
  },
  negative: {
    labelKey: 'headwind',
    className: styles.negative,
    chartColor: '--viz-bearish',
  },
  neutral: {
    labelKey: 'neutral',
    className: styles.neutral,
    chartColor: '--icon-soft',
  },
};
